<script>
import { componentStore } from "@common/componentStore/componentStore.js";

const positionPlaceholderConfig = {
    cId: "positionPlaceholder",
    cType: "positionPlaceholder",
    cTitle: "Position Placeholder",
    cTemplate: `<div :id="positionId" class="position-placeholder">Position {{positionIndex}}</div>`
};

const editorConfig = {
    editorDescription: { type: "INFO", text: "The buildInfo component displays the build information for our current product environment. There are no settings to modify." },
    DocumentationUrl: { type: "URL", text: "Build Info Documentation", url: "https://samaritan.atlassian.net/wiki/spaces/DEVELOPMEN/pages/473464857/buildInfo" }
};

const positionPlaceholderCmp = {
    name: 'positionPlaceholder',
    editorSettings: editorConfig,
    data() {
        return {
            editorSettings: editorConfig,
            positionIndex: 0
        };
    },
    computed: {
        positionId() {
            return 'position_placeholder_id_' + this.positionIndex;
        }
    },
    methods: {
        onLoad() {
            this.positionIndex = this.cId.split("__")[1];
        },
    }
};

componentStore.initComponent(positionPlaceholderCmp, positionPlaceholderConfig);
export { positionPlaceholderCmp, positionPlaceholderConfig };
export default positionPlaceholderCmp;
</script>

<style>
    .position-placeholder {
        font-size: 24px !important;
        text-align: center !important;
        border:4px solid white !important;
        background: #ffdb28 !important;
        padding: 10px !important;
        color: black !important;
    }
</style>
